import { promise } from '../../../helpers';
import { getItemsFromSnapshot } from '../../../helpers/firebase';

const getTeamTasks = ({ where }) => {
    // eslint-disable-next-line no-unused-vars
    return (dispatch, getState, getFirebase) => {
        let query = getFirebase()
            .firestore()
            .collection('teamTasks');

        if (where && where.length) {
            for (let i = 0; i < where.length; i += 1) {
                query = query.where(where[i][0], where[i][1], where[i][2]);
            }
        }

        return query.get().then(snapshot => promise(getItemsFromSnapshot(snapshot)));
    };
};

export default getTeamTasks;
